<template>
  <div
    :id="'p'+page.id"
    :class="'page '+report.paper_size+' '+report.orientation"
  >
    <div
      v-if="pageExceedsBoundary"
      :class="'page_boundary '+report.paper_size+' '+report.orientation"
    >
      <div>
        End of Page
      </div>
    </div>

    <div
      :class="'page-header '+report.paper_size+' '+report.orientation"
      :style="'background: '+report.header_color+'; color: '+report.header_text_color+'; font-family: '+report.header_font+';'"
      @mouseleave="showEditHeader = false"
      @mouseover="showEditHeader = true"
    >
      <transition name="fade">
        <div
          v-show="showEditHeader && !preview"
          class="edit_btn edit_header"
          @click="openReportModal({report: report, type: type, section: 'header'})"
        >
          <span>Edit Header</span>
        </div>
      </transition>
      <img
        :src="report.logo_src"
        class="header_logo"
      >
      <span style="text-align: right;">
        {{ report.header_text }}
        <br v-if="dateRange">
        <small v-if="dateRange">{{ dateRange }}</small>
        <br v-if="compRange">
        <small v-if="compRange">Compare to: {{ compRange }}</small>
      </span>
    </div>

    <div :class="'page-content '+report.paper_size+' '+report.orientation">
      <slot />
    </div>

    <div
      :class="'page-footer '+report.paper_size+' '+report.orientation"
      :style="'background: '+report.footer_color+'; color: '+report.footer_text_color+'; font-family: '+report.footer_font+';'"
      @mouseleave="showEditFooter = false"
      @mouseover="showEditFooter = true"
    >
      <transition name="fade">
        <div
          v-show="showEditFooter && !preview"
          class="edit_btn edit_footer"
          @click="openReportModal({report: report, type: type, section: 'footer'})"
        >
          <span>Edit Footer</span>
        </div>
      </transition>
      <div>
        <span
          v-if="report.include_page_no"
          class="page-number"
        >{{ index + 1 }}</span>
      </div>
      <div>{{ report.footer_text }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {mapActions, mapState} from 'vuex';
import moment from 'moment';

export default {
  props: {
    page: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  emits: ['loaded'],
  data() {
    return {
      showEditHeader: false,
      showEditFooter: false,
      pageExceedsBoundary: false,
      pageSizes: {
        A4: {
          landscape: {
            page: {
              height: 209.5,
              width: 297
            },
            header: {
              height: 21,
              fontSize: 12,
              padding: 3
            },
            content: {
              height: 179
            },
            footer: {
              height: 9.5,
              fontSize: 9,
              padding: 3
            },
          },
          portrait: {
            page: {
              height: 297,
              width: 210
            },
            header: {
              height: 30,
              fontSize: 12,
              padding: 3
            },
            content: {
              height: 252
            },
            footer: {
              height: 15,
              fontSize: 9,
              padding: 3
            },
          },
        }
      }
    }
  },
  computed: {
    ...mapState('report', ['report', 'type']),

    dateRange() {
      if (this.report.include_date_range) {
        return moment(this.report.from_date).format(this.report.date_format) + ' - ' + moment(this.report.to_date).format(this.report.date_format);
      }
      return null;
    },
    compRange() {
      if (this.report.include_date_range) {
        let compRange = null;

        if (this.report.comp_range && this.report.comp_range !== 'custom') {
          compRange = _.capitalize(this.report.comp_range).replace(/_/g, ' ');
          
        } else if (this.report.comp_range && this.report.comp_range === 'custom') {
          compRange = moment(this.report.comp_from_date).format(this.report.date_format) + ' - ' + moment(this.report.comp_to_date).format(this.report.date_format);
        }

        return compRange;
      }
      return null;
    }

  },
  mounted() {
    if (!this.preview) {
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          let minHeight = parseInt(window.getComputedStyle(entry.target).getPropertyValue('min-height').replace('px', ''));
          this.pageExceedsBoundary = entry.target.offsetHeight > (minHeight + 5);
        }
      })
      resizeObserver.observe(document.getElementById('p' + this.page.id));
      this.$emit('loaded');
    }
  },
  methods: {
    ...mapActions({
      openReportModal: 'reportModal/openModal'
    })
  }
}
</script>
<style src="./../../../../../css/reports/page.css"></style>

<style>
.page {
  font-family: v-bind('report.font');
}

.page-content {
  padding: 0 10px;
}

.page_boundary {
  z-index: 10;
  display: flex;
  justify-content: center;
  position: absolute;
  height: 1px;
  border: solid 1px orange;
}

.page_boundary > div {
  position: absolute;
  padding: 4px;
  border: 1px solid orange;
  border-radius: 0 0 .5rem .5rem;
  background-color: white;
  overflow: hidden;
}

.page {
  position: relative;
  margin: 10mm auto;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.page-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.edit_btn {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 15%;
  font-size: 0.875rem;
  line-height: 1.72;
  letter-spacing: -0.00715em;
  color: white;
  background-color: #37B2A8;
  padding: 9px 1rem;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  justify-content: center;
  cursor: pointer;
}

.edit_header {
  top: 0;
  border: solid 1px white;
  border-top: none;
  border-radius: 0 0 .75rem .75rem;
}

.edit_footer {
  bottom: 0;
  border: solid 1px white;
  border-bottom: none;
  border-radius: .75rem .75rem 0 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header_logo {
  max-width: 70%;
  max-height: 100%;
  display: block;
}

.page-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.edit-widget {
  position: absolute;
  top: 0;
  right: 0;
  padding-top: 10px;
  padding-right: 15px;
  cursor: pointer;
}

.widget-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 25pt;
}

.widget-stat-box {
  border-radius: 10px;
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 5%);
  border: none !important;
  background-color: #ffffff;
  height: 100%;
}

.stat-source {
  display: flex;
  justify-content: flex-end;
  font-size: .5rem;
  padding-right: 5px;
}

.stat-value {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .page:last-child {
    page-break-after: auto;
  }

  .page_boundary {
    display: none;
  }

  @page {
    margin: 0;
  }

  html, body {
    background: white;
  }
}
</style>
